<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:40px 0 0 0">
                <h1 class="key-number">Plans &amp; Pricing</h1>
            </div>
        </div>

        <Plans :what_are_you_waiting_for="false"/>

        <Footer/>
    </div>
</template>

<style>
</style>

<script>
    import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
    import Plans from "../components/Plans";
    import Footer from "../components/Footer";

    export default {
        components: {
             HeaderMenu, NetworkStatus, Plans, Footer
        }
    }
</script>
